import { useEffect, useState } from "react";
import type { MobPersona } from "../api/mob-persona";
import { getMobPersonaProfile, listMobPersonas } from "../api/mob-persona";
import { MobPersonaModal } from "./mob-persona-modal";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Textarea } from "./ui/textarea";

interface EditProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: { profile?: string }) => void;
  initialProfile?: string;
  token?: string;
}

export function EditProfileModal({ isOpen, onClose, onSave, initialProfile, token }: EditProfileModalProps) {
  const [profile, setProfile] = useState<string>(initialProfile ?? "");
  const [isPersonaModalOpen, setIsPersonaModalOpen] = useState(false);
  const [personas, setPersonas] = useState<MobPersona[]>([]);

  useEffect(() => {
    setProfile(initialProfile ?? "");
  }, [initialProfile]);

  useEffect(() => {
    const fetchPersonas = async () => {
      if (token) {
        try {
          const response = await listMobPersonas(token);
          setPersonas(response.mob_personas);
        } catch (error) {
          console.error("Failed to fetch personas:", error);
        }
      }
    };
    fetchPersonas();
  }, [token]);

  const handleSave = () => {
    onSave({ profile: profile.length > 0 ? profile : undefined });
    onClose();
  };

  const handlePersonaSelect = async (id: string) => {
    const p = await getMobPersonaProfile(token ?? "", id);

    setProfile(p.profile);
    setIsPersonaModalOpen(false);
  };

  return (
    <>
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle>プロフィールの編集</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div className="flex justify-end">
              <Button onClick={() => setIsPersonaModalOpen(true)} variant="outline">
                ペルソナ一覧からインポート
              </Button>
            </div>
            <div>
              <Textarea
                id="profile"
                value={profile}
                onChange={(e) => setProfile(e.target.value)}
                rows={10}
                className="w-full"
              />
            </div>
          </div>
          <DialogFooter>
            <Button onClick={onClose} variant="outline">
              キャンセル
            </Button>
            <Button onClick={handleSave}>保存</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <MobPersonaModal
        isOpen={isPersonaModalOpen}
        onClose={() => setIsPersonaModalOpen(false)}
        onSelect={handlePersonaSelect}
        personas={personas}
      />
    </>
  );
}
